export const LOCAL_ADMIN_PARAMETERS = "AdminParameters";
export const LAST_ACTIVITY = "LastActivity";

export class LocalStorageService {
  static saveData<T>(key: string, data: T): void {
    if (typeof localStorage === "undefined") {
      console.error("localStorage is not defined in this environment.");
      return;
    }
    try {
      const currentDataStr = localStorage.getItem(key);
      let mergedData: any;
      if (currentDataStr) {
        mergedData = JSON.parse(currentDataStr);
        for (const prop in data) {
          if (Object.prototype.hasOwnProperty.call(mergedData, prop)) {
            mergedData[prop] = (data as any)[prop];
          }
        }
      } else {
        mergedData = data;
      }
      localStorage.setItem(key, JSON.stringify(mergedData));
    } catch (error) {
      console.error("Error saving data to localStorage:", error);
    }
  }

  static getData<T>(key: string): T | null {
    if (typeof localStorage === "undefined") {
      console.error("localStorage is not defined in this environment.");
      return null;
    }
    const item = localStorage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error("Error parsing data from localStorage:", error);
      return null;
    }
  }
}
